import { render } from "./FAQList.vue?vue&type=template&id=74251c61&scoped=true"
import script from "./FAQList.vue?vue&type=script&lang=js"
export * from "./FAQList.vue?vue&type=script&lang=js"

import "./FAQList.vue?vue&type=style&index=0&id=74251c61&scoped=true&lang=scss"

import exportComponent from "/pxplus_official_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74251c61"]])

export default __exports__